(function(){"use strict";try{if(typeof document<"u"){var n=document.createElement("style");n.appendChild(document.createTextNode(`._playIcon_3xgwd_1{background:transparent;border:0 none;cursor:pointer;left:50%;position:absolute;text-align:center;top:50%;transform:translate(-50%,-50%)}._playIcon_3xgwd_1 span{border-radius:50%;color:var(--neu-plain-0);font-size:78px;transition-duration:.2s;transition-property:transform;font-variation-settings:normal}._playIcon_3xgwd_1:hover i,._playIcon_3xgwd_1:focus i{transform:scale(1.3)}._opacity_3xgwd_23{opacity:.77}
._extendedDropdown_17k1l_1 .unit-dropdown .dropdown-menu{max-height:clamp(150px,80vh,500px)!important}
@media (min-width: 992px){._overlay_1tz1r_2{margin-top:-6rem}}@media (min-width: 992px){._corpOverlay_1tz1r_8{margin-top:-8rem}}._hideEmpty_1tz1r_13:has(>div:empty){display:none}
._richText_1ghed_1 a:not(._neu-button_1ghed_1){color:var(--neu-plain-0);font-size:14px;text-decoration:none}._richText_1ghed_1 a:not(._neu-button_1ghed_1):hover,._richText_1ghed_1 a:not(._neu-button_1ghed_1):focus{background:none;text-decoration:underline;color:var(--neu-plain-0);border:none}._richText_1ghed_1 strong{font-weight:600}._richText_1ghed_1 hr{border:none;background-color:var(--neu-plain-0);height:1px;width:100%;margin:20px 0}a._corpLinks_1ghed_24{color:var(--neu-plain-0);text-decoration:none}a._corpLinks_1ghed_24:hover,a._corpLinks_1ghed_24:focus{background:none;text-decoration:underline;color:var(--neu-plain-0);border:none}._containerFlex_1ghed_37{padding:35px}@media (min-width: 992px){._containerFlex_1ghed_37{padding:35px 72px}}
@media (min-width: 576px){._standaloneSearch_10kr5_2{min-width:20rem}}._standaloneSearch_10kr5_2 .unit-dropdown{width:100%}._standaloneSearch_10kr5_2 .neu-form--support:empty{display:none}._standaloneSearch_10kr5_2 .unit-wrapper:before{all:unset}._standaloneSearch_10kr5_2 .neu-form__native{padding:var(--form-padding);padding-right:calc(40px + var(--neu-spacer-3));min-width:18rem}._standaloneSearch_10kr5_2 .neu-form__native::-webkit-search-cancel-button{margin-top:.1rem}@media (min-width: 992px){._corporateStandalone_10kr5_25{min-width:19rem}._corporateStandalone_10kr5_25 label{color:var(--neu-plain-0)}}._standaloneSearch_10kr5_2+.input-spinner{--feedback-padding-right: calc(40px + var(--neu-spacer-3));--feedback-padding-bottom: var(--neu-spacer-3)}._standaloneButton_10kr5_37.with-label{top:calc(1.375rem + var(--neu-spacer-2))}`)),document.head.appendChild(n)}}catch(e){console.error("vite-plugin-css-injected-by-js",e)}})();
import { jsx as r, jsxs as d, Fragment as V } from "react/jsx-runtime";
import n from "react";
import { useI18n as le } from "next-localization";
import { c as g } from "./clsx.OuTLNxxd.js";
import { useFormContext as ie, useForm as se, Controller as de } from "react-hook-form";
import { NeuSearch as ce, NeuIcon as j } from "@hcahealthcaredpx/neutron-react";
import { H as pe } from "./highlight-text.lum-VI9X.js";
import { I as fe } from "./input-spinner.DnwawoS3.js";
import { M as ue } from "./module-link.BIP-6VCP.js";
const E = 3, he = "storedLocation", xe = "_extendedDropdown_17k1l_1", ge = {
  extendedDropdown: xe
}, ye = n.forwardRef(
  ({
    className: C,
    disabled: L,
    color: q,
    items: l,
    itemsLoading: c = !1,
    name: a,
    placeholder: z,
    label: G,
    labelHidden: J = !1,
    selectItemIcon: H,
    onSelected: F,
    onTypeaheadKeyPress: y,
    onNeuBlur: b,
    onNeuFocus: S,
    resultsCTA: i,
    popperStrategy: Q,
    invalid: p,
    debounce: U = 100,
    selectItem: v = null,
    onCtaClick: O,
    onKeyUp: m,
    isGlobalSiteSearch: W,
    ...X
  }, Y) => {
    const [t, w] = n.useState(null), [$, f] = n.useState(!0), [Z, A] = n.useState(void 0), u = n.useRef(!0), { t: R } = le(), B = ie(), K = se(), T = B || K, { control: P, setValue: N, setFocus: ee, watch: te } = T, o = te(a);
    n.useEffect(() => {
      v && w(v);
    }, [v]), n.useEffect(() => {
      async function h() {
        F && await F(t), t && N(a, t.preferredValue ?? t.value);
      }
      h(), A(
        $ && t && t.id && t.id !== he ? `${a}-typeahead-option-${t.id}` : void 0
      );
    }, [t]);
    const [D, I] = n.useState(!1);
    n.useEffect(() => {
      I(!1), o && o.length >= E && (u.current = !1), u.current || f(
        !!o && o.length >= E - 1 && !t && !p
      );
    }, [o, p, t]);
    const M = (h, s) => {
      s.onSelected && s.onSelected(), w(s), N(a, s.preferredValue ?? s.value), ee(a, { shouldSelect: !1 });
    };
    if (!l)
      return null;
    const ae = g(
      "neu-text-caption neu-bg-plain-0 neu-bg-gray-10-hover cursor-pointer py-1 transition-background-color duration-300"
    ), oe = g("neu-text-support", "neu-bg-gray-0", "py-0");
    return /* @__PURE__ */ r(
      de,
      {
        name: a,
        control: P,
        render: ({ field: h }) => {
          const { onBlur: s, ...re } = h, { onBlur: k, onFocus: _, ...ne } = X;
          return /* @__PURE__ */ d("div", { className: g("position-relative d-flex flex-column justify-content-center"), children: [
            /* @__PURE__ */ d(
              ce,
              {
                autoComplete: "off",
                className: g(
                  "typeahead",
                  C,
                  ge.extendedDropdown,
                  c ? "loading" : ""
                ),
                dropdown: $,
                color: q,
                label: G,
                labelHidden: J,
                popperStrategy: Q,
                disabled: L,
                debounce: U,
                placeholder: z,
                invalid: p,
                role: "combobox",
                "aria-label": R("Search.Result.Results"),
                "aria-autocomplete": "list",
                "aria-haspopup": "listbox",
                "aria-controls": `${a}-typeahead-listbox`,
                "aria-expanded": $,
                "aria-describedby": `${a}-typeahead-noresults ${a}-typeahead-searchstatus`,
                "aria-activedescendant": Z,
                onKeyUp: (e) => {
                  m && m(e), W && e.key === "Enter" && f(!1);
                },
                onNeuChange: (e) => {
                  w(null), y == null || y(e.value), I(!0), !e.value && !u.current && N(a, void 0);
                },
                onNeuFocus: (e) => {
                  u.current || f(
                    !!o && o.length >= E && !t && !p
                  ), S == null || S(e), _ == null || _(e);
                },
                onNeuBlur: (e) => {
                  s(), b == null || b(e), k == null || k(e);
                },
                ...re,
                ...ne,
                ref: Y,
                children: [
                  D && /* @__PURE__ */ d(V, { children: [
                    l.length > 0 && l.map((e) => /* @__PURE__ */ r(
                      "div",
                      {
                        tabIndex: 0,
                        id: `${a}-typeahead-option-${e.id}`,
                        role: "option",
                        "aria-disabled": e.isHeader ? "true" : "false",
                        "aria-selected": (t == null ? void 0 : t.id) === e.id,
                        className: `d-flex align-items-center px-2 ${e.isHeader ? oe : ae}`,
                        onClick: (x) => {
                          e.isHeader || M(x, e);
                        },
                        onKeyDown: (x) => {
                          !e.isHeader && x.key === "Enter" && M(x, e);
                        },
                        children: /* @__PURE__ */ d("div", { children: [
                          H && /* @__PURE__ */ r(
                            j,
                            {
                              name: H,
                              className: "pe-1"
                            }
                          ),
                          /* @__PURE__ */ r(pe, { text: e == null ? void 0 : e.value, highlight: o })
                        ] })
                      },
                      e.id
                    )),
                    l.length > 0 && i && /* @__PURE__ */ r("div", { className: "w-100 px-2 py-1 border-top border-neu-gray-10", children: /* @__PURE__ */ d(
                      ue,
                      {
                        className: "neu-text-caption p-0 neu-link--forced",
                        href: i.link.href,
                        target: i.link.target,
                        rel: i.link.rel,
                        role: "option",
                        id: `${a}-typeahead-option-cta`,
                        "aria-selected": !1,
                        onClick: (e) => {
                          O && (O(e), f(!1));
                        },
                        children: [
                          i.label,
                          /* @__PURE__ */ r(j, { name: "arrow_right_alt", className: "ps-1" })
                        ]
                      }
                    ) })
                  ] }),
                  !c && l.length > 0 && D && /* @__PURE__ */ d(
                    "div",
                    {
                      "aria-live": "polite",
                      role: "option",
                      className: "sr-only",
                      id: `${a}-typeahead-searchstatus`,
                      children: [
                        `${l.length} results found for ${o}`,
                        i && /* @__PURE__ */ d(V, { children: [
                          ". ",
                          `Last option is ${i.label}`
                        ] })
                      ]
                    }
                  ),
                  !c && l.length < 1 && D && /* @__PURE__ */ r(
                    "div",
                    {
                      "aria-live": "polite",
                      role: "option",
                      className: "d-flex align-items-center p-1",
                      "aria-label": R("Search.Result.NoKeyword"),
                      id: `${a}-typeahead-noresults`,
                      children: /* @__PURE__ */ r("span", { className: "neu-text-caption", children: R("Search.Result.NoKeyword") })
                    }
                  )
                ]
              }
            ),
            /* @__PURE__ */ r(fe, { isLoading: c })
          ] });
        }
      }
    );
  }
);
ye.displayName = "Typeahead";
export {
  E as M,
  he as S,
  ye as T
};
